module.exports = "/assets/2b00a79c904702d107c8f0e0f08cd5c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4N.png
// module id = 2170
// module chunks = 0